import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/icon_HiOutlineDocumentDownload.svg'


const _hoisted_1 = {
  key: 0,
  class: "institutional-identification"
}
const _hoisted_2 = { class: "row fit no-wrap items-center content-start q-pb-md" }
const _hoisted_3 = { class: "col-6 col-md-6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "midia-app-content-lg" }
const _hoisted_6 = { class: "col-6 col-md-6" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "midia-app-content-lg status-value" }
const _hoisted_9 = { class: "row fit no-wrap content-start q-pb-md" }
const _hoisted_10 = { class: "col-6 col-md-6" }
const _hoisted_11 = { class: "q-pb-md" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "midia-app-content-lg" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-4 col-md-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "midia-app-content-lg" }
const _hoisted_18 = { class: "col-4 col-md-4" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "midia-app-content-lg" }
const _hoisted_21 = { class: "col-6 col-md-6" }
const _hoisted_22 = { class: "row fit no-wrap items-center q-pb-xs" }
const _hoisted_23 = { class: "row q-py-xs" }
const _hoisted_24 = {
  key: 0,
  class: "row fit content-start q-pb-md"
}
const _hoisted_25 = { class: "col-6 col-md-6" }
const _hoisted_26 = { class: "row fit no-wrap items-center q-pb-xs" }
const _hoisted_27 = { class: "row q-py-xs" }

import { computed } from 'vue'
import { EnumButtonSizes } from '@/enums/enums'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { useRedeSubredeStore } from '@/stores/redeSubredeStore'
import messages from '@/utils/messages'

import { usePCStore } from '@/stores/pcStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'InstitutionalIdentificationSectionView',
  props: {
    institutionalData: {},
    showDownloadButtons: { type: Boolean }
  },
  setup(__props: any) {

const pcStore = usePCStore()

const redeSubredeStore = useRedeSubredeStore()
const institutionalStore = useInstitutionalStore()

const props = __props

// ✅ pcsPorGrupo do backend: { D0: [...], D1: [...], D2: [...], D3: [...] }
const pcsPorGrupo = computed<Record<string, any[]>>(() =>
  props.institutionalData?.pcsPorGrupo || {}
)

// ✅ grupos disponíveis ordenados
const gruposDisponiveis = computed(() =>
  Object.keys(pcsPorGrupo.value).sort()
)

// ✅ true se tem mais de um grupo
const temGrupos = computed(() => gruposDisponiveis.value.length > 1)

// ✅ todos os PCs em lista flat
const todosOsPcs = computed(() =>
  Object.values(pcsPorGrupo.value).flat()
)

const getStatusLabel = (statusId: number): string => {
  const id = Number(statusId)
  switch (id) {
    case CONST_INSTITUTIONAL_STATUS.DRAFT.id: return 'Rascunho'
    case CONST_INSTITUTIONAL_STATUS.ON_EDITING.id: return 'Em Edição'
    case CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id: return 'Em Aprovação'
    case CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED.id: return 'Solicitado Ajuste'
    case CONST_INSTITUTIONAL_STATUS.APPROVED.id: return 'Aprovado'
    case CONST_INSTITUTIONAL_STATUS.PENDING_PUBLICATION.id: return 'Pendente Publicação'
    case CONST_INSTITUTIONAL_STATUS.PUBLISHED.id: return 'Publicado'
    case CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id: return 'Ativo'
    case CONST_INSTITUTIONAL_STATUS.ON_REISSUE.id: return 'Em Reedição'
    case CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id: return 'Em Reaprovação'
    case CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED_AGAIN.id: return 'Solicitado Reajuste'
    case CONST_INSTITUTIONAL_STATUS.REAPPROVED.id: return 'Reaprovado'
    case CONST_INSTITUTIONAL_STATUS.CANCELED.id: return 'Cancelado'
    case CONST_INSTITUTIONAL_STATUS.INSTITUTIONAL_COMPLETED.id: return 'Concluído'
    case CONST_INSTITUTIONAL_STATUS.HISTORICO.id: return 'Histórico'
    default: return ''
  }
}

// ✅ Gera e faz download do CSV
/*const gerarCsvDownload = (pcs: any[], nomeArquivo: string) => {
  if (!pcs?.length) return

  const header = ['Codigo PC', 'Nome', 'UF', 'Cidade', 'Segmento', 'Subrede']

  const rows = pcs.map((pc: any) => [
    pc.codpontocaptura,
    pc.nompontocaptura,
    pc.ufredeautoatndto || '-',
    pc.nomcidredeautoatndto || '-',
    pc.nomsegmmerclocalptoatndto || '-',
    pc.nomsubredeautoatndto || '-'
  ])

  const csvContent = [
    header.join(';'),
    ...rows.map((row: any) => row.join(';'))
  ].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = nomeArquivo
  link.click()
  URL.revokeObjectURL(url)
} */

/*const gerarCsvDownload = (pcs: any[], nomeArquivo: string) => {
  if (!pcs?.length) return

  const header = ['Codigo PC', 'Nome', 'UF', 'Cidade', 'Segmento', 'Subrede']

  const rows = pcs.map((pc: any) => [
    pc.codpontocaptura ?? '-',
    pc.nompontocaptura ?? '-',        // 👈 usa direto
    pc.ufredeautoatndto ?? '-',
    pc.nomcidredeautoatndto ?? '-',
    pc.nomsegmmerclocalptoatndto ?? '-',
    pc.nomsubredeautoatndto ?? '-'
  ])

  const csvContent = [
    header.join(';'),
    ...rows.map(row => row.join(';'))
  ].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = nomeArquivo
  link.click()

  URL.revokeObjectURL(url)
}*/


const onDownloadPcsCsvPorGrupo = (grupo: string) => {
  if (!props.institutionalData?.id) {
    messages.showWarningMsg('Nenhum PC disponível para download')
    return
  }

  institutionalStore.downloadPcsByTela(
    props.institutionalData.id,
    grupo
  )
}



const onDownloadPcsCsv = () => {
  const telaId = props.institutionalData?.id

  if (!telaId) {
    messages.showWarningMsg('Nenhum PC disponível para download')
    return
  }

  institutionalStore.downloadPcsByTela(telaId)
}

const onDownloadRedesCsv = async () => {
  let redes = props.institutionalData.redes || []

  // ✅ fallback: montar a partir das subredes selecionadas
  if (!redes.length) {
    redes = (redeSubredeStore.subredesSelecionadas || []).map((s: any) => ({
      codRede: s.codRedeAutoAtndto,
      codSubrede: s.codSubredeAutoAtndto
    }))
  }

  if (!redes.length) {
    console.warn('Nenhuma rede/subrede selecionada')
    return
  }

  if (!redeSubredeStore.subredes.length) {
    await redeSubredeStore.carregarSubredes()
  }

  const header = ['Rede', 'Nome Rede', 'Subrede', 'Nome Subrede']

  const rows = redes.map((r: any) => {
    const subrede = redeSubredeStore.subredes.find(
      s => s.codSubredeAutoAtndto === r.codSubrede
    )

    return [
      r.codRede,
      subrede?.nomRedeAutoAtndto || '-',
      r.codSubrede,
      subrede?.nomSubredeAutoAtndto || '-'
    ]
  })

  const csvContent = [
    header.join(';'),
    ...rows.map((row: any) => row.join(';'))
  ].join('\n')

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'redes_subredes.csv')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  URL.revokeObjectURL(url)
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (__props.institutionalData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row" }, [
              _createElementVNode("span", { class: "midia-app-caption-sm" }, "Cadastro")
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(__props.institutionalData.nome), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "midia-app-label-lg q-pr-sm" }, "Status:", -1)),
              _createElementVNode("span", _hoisted_8, _toDisplayString(getStatusLabel(__props.institutionalData.status)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row" }, [
                _createElementVNode("span", { class: "midia-app-caption-sm" }, "Perfil")
              ], -1)),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(__props.institutionalData.perfil), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("span", { class: "midia-app-caption-sm" }, "Data Inicial")
                ], -1)),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(__props.institutionalData.dtIniVigencia), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row" }, [
                  _createElementVNode("span", { class: "midia-app-caption-sm" }, "Data Final")
                ], -1)),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(__props.institutionalData.dtFimVigencia || '-'), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", null, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row q-pb-xs" }, [
                _createElementVNode("span", { class: "midia-app-label-sm" }, "Redes / Sub-redes")
              ], -1)),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_q_icon, { size: "32px" }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "download"
                    }, null, -1)
                  ]))]),
                  _: 1
                }),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "midia-app-label-lg q-pl-sm" }, "Rede / Subrede", -1))
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_c_q_btn, {
                  propBtnLabel: "Download",
                  propBtnFunction: onDownloadRedesCsv,
                  propBtnTransparent: true,
                  propBtnSize: _unref(EnumButtonSizes).SMALL
                }, null, 8, ["propBtnSize"])
              ])
            ])
          ])
        ]),
        (__props.showDownloadButtons !== false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row q-pb-xs" }, [
                    _createElementVNode("span", { class: "midia-app-label-sm" }, "PCs")
                  ], -1)),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_q_icon, { size: "32px" }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: "download"
                        }, null, -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "midia-app-label-lg q-pl-sm" }, "PCs", -1))
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    (temGrupos.value)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(gruposDisponiveis.value, (grupo) => {
                          return (_openBlock(), _createBlock(_component_c_q_btn, {
                            key: grupo,
                            propBtnLabel: `Download ${grupo}`,
                            propBtnFunction: () => onDownloadPcsCsvPorGrupo(grupo),
                            propBtnTransparent: true,
                            propBtnSize: _unref(EnumButtonSizes).SMALL,
                            class: "q-mr-sm"
                          }, null, 8, ["propBtnLabel", "propBtnFunction", "propBtnSize"]))
                        }), 128))
                      : (_openBlock(), _createBlock(_component_c_q_btn, {
                          key: 1,
                          propBtnLabel: "Download",
                          propBtnFunction: () => onDownloadPcsCsv(),
                          propBtnTransparent: true,
                          propBtnSize: _unref(EnumButtonSizes).SMALL
                        }, null, 8, ["propBtnFunction", "propBtnSize"]))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})